import { Injectable } from '@angular/core';
import {
  CheckoutLinkedAccountPosition,
  CheckoutSubmitButtonPosition,
  TransferConnectV2SettingService,
} from '@features/transfer-connect-v2/services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { ButtonTheme, SuccessButton, SuccessButtonGroup } from '@rd/types';

@Injectable()
export class StarTransferConnectV2SettingService extends TransferConnectV2SettingService {
  /*
  ====================================
    Listing page-only settings
  ====================================
  */

  shouldPrefillLinkAccountForm = true;
  shouldDisablePrefilledLinkAccountFields = true;
  listItemDesktopButtonTheme: ButtonTheme = 'outline-primary';
  showListingFilters = true;
  showCategoryFilter = false;
  submitButtonPosition: CheckoutSubmitButtonPosition = 'outside';
  linkedAccountPosition: CheckoutLinkedAccountPosition = 'outside';
  shouldRenderReviewTnc = true;

  successButtons(): SuccessButtonGroup {
    const makeAnotherRedemptionButton: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'transfer_v2.success.make_another_redemption',
      buttonTheme: 'primary',
      redirectURL: '/transfer/programs',
    };

    const toPointsTransactionButton: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'transfer_v2.success.see_points_transaction',
      buttonTheme: 'secondary',
      redirectURL: '/points_activity',
    };

    return {
      confirmed: [
        { ...toPointsTransactionButton, buttonTheme: 'outline-primary' },
        makeAnotherRedemptionButton,
      ],
      pending: [
        { ...makeAnotherRedemptionButton, buttonTheme: 'outline-primary' },
        { ...toPointsTransactionButton, buttonTheme: 'primary' },
      ],
      failed: [
        {
          ...makeAnotherRedemptionButton,
          buttonText: 'wl.star.transfer_v2.success.try_again',
          buttonTheme: 'outline-primary',
        },
        { ...toPointsTransactionButton, buttonTheme: 'primary' },
      ],
    };
  }
}
